import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface Icon {
  name: string;
  icon: string;
}

@Injectable({
  providedIn: 'root',
})
export class IconManager {
  private _matIconRegistry = inject(MatIconRegistry);
  private _domSanitizer = inject(DomSanitizer);
  private _registeredIcons = new Set<string>();
  private _rawIconMap = new Map<string, string>();

  icons$: Subject<Icon[]> = new Subject();

  constructor() {
    this.icons$.pipe(takeUntilDestroyed()).subscribe((icons) =>
      icons.forEach((icon) => {
        this._addIcon(icon);
      })
    );
  }

  public addIcons(icons: Icon[]) {
    const newIcons = icons.filter(
      (icon) => !this._registeredIcons.has(`twc:${icon.name}`)
    );
    if (newIcons.length > 0) {
      this.icons$.next(newIcons);
    }
  }

  private _addIcon({ name, icon }: Icon) {
    const iconKey = `twc:${name}`;
    if (!this._registeredIcons.has(iconKey)) {
      this._matIconRegistry.addSvgIconLiteralInNamespace(
        'twc',
        name,
        this._domSanitizer.bypassSecurityTrustHtml(icon)
      );

      this._rawIconMap.set(name, icon);

      this._registeredIcons.add(iconKey);
    }
  }

  public getRawIcon(name: string): string | null {
    return this._rawIconMap.get(name) ?? null;
  }
}
